@if (data) {
  <div class="tw-flex tw-items-center" [ngClass]="[alignment(), customCssClasses]">
    <pot-button
      class="tw-w-auto"
      [buttonStyle]="data.buttonStyle!"
      [aosAnimation]="data.aosAnimation ?? null"
      (clicked)="onClick()"
    >
      {{ data.label }}
    </pot-button>
  </div>
}
